import React from 'react';
import { Link } from "react-router-dom";
import iconTop from '../assets/arrow-up-right-svgrepo-com (1).svg';
import iconBottomup from '../assets/statistic-up.svg';
import iconBottomdown from '../assets/statistic-down.svg';

const stats = [
  {
    title: 'Total Revenue',
    value: '$81.000',
    change: '+10.6%',
    color: 'text-green-500',
    gradient: false,
    bg: 'agarly-gradient-bg',
    bottomIcon: iconBottomup,
    link: '/sales',
  },
  {
    title: 'Total Customer',
    value: '5.000',
    change: '+1.5%',
    color: 'text-green-500',
    gradient: true,
    bg: 'bg-white',
    bottomIcon: iconBottomup,
    link: '/Users?selected=customers',
  },
  {
    title: 'Total Transactions',
    value: '12.000',
    change: '+3.6%',
    color: 'text-green-500',
    gradient: true,
    bg: 'bg-white',
    bottomIcon: iconBottomup,
    link: '/transactions',
  },
  {
    title: 'Total Product',
    value: '5.000',
    change: '-1.5%',
    color: 'text-red-500',
    gradient: true,
    bg: 'bg-white',
    bottomIcon: iconBottomdown,
    link: '/products?selected=clothing'
  },
];

const StatsCardsandBanner = () => {
return (
  <>
    <div className="flex flex-col w-full gap-6">
      <div className="grid grid-cols-2 gap-4 min-w-[350px] ">
        {stats.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className={`p-4 rounded-[24px] shadow-sm ${item.bg} flex flex-col min-w-[125px] h-[160px] w-full flex-1 hover:-translate-y-1 hover:shadow-lg transition dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]`}
          >
          
            {/*first section*/}
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-base font-medium text-gray-600 dark:text-gray-200">{item.title}</h4>
              <img src={iconTop} alt="" className="w-5 h-5" />
            </div>

            {/*second section */}
            <div className="flex-1 flex flex-wrap items-end justify-between">
              {/* number */}
              <div
                className={`text-3xl font-extrabold ${item.gradient
                  ? 'agarly-gradient-text'
                  : 'text-white'}`}
              >
                {item.value}
              </div>

              {/* percentage */}
              <div className="flex justify-between gap-6 md:gap-0 lg:flex-col items-end text-sm">
                <div className={`flex items-center ${item.color}`}>
                  <img src={item.bottomIcon} alt="" className="w-4 h-4 " />
                  <span className={`${item.color} text-xs`}>{item.change}</span>
                </div>
                <span className="text-[12px] text-gray-400"> &nbsp; From last week</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div
        className="promotion-card min-w-[350px] relative overflow-hidden box-border flex flex-col justify-between items-start p-6 rounded-[24px] text-white shadow-md flex-1 isolate agarly-gradient-bg"
      >
        {/* Decorative blur elements */}
        <div className="absolute w-[250px] h-[250px] left-[-61px] top-[-165px] bg-[rgba(26,113,246,0.5)] opacity-50 blur-[50px] z-0"></div>
        <div className="absolute w-[250px] h-[250px] left-[283px] top-[-116px] bg-[rgba(93,50,108,0.5)] opacity-90 blur-[40px] z-1"></div>
        <div className="absolute w-[269px] h-[275px] left-[81px] top-[68px] bg-[rgba(26,113,246,0.5)] blur-[70px] z-2"></div>

        {/* Decorative vector elements */}
        <div className="absolute w-[206px] h-[206px] left-[350px] top-[-188px] bg-[rgba(217,237,255,0.4)] rounded-[6px] rotate-[20.53deg] z-5"></div>
        <div className="absolute w-[167px] h-[206px] left-[310px] top-[153.49px] border-4 border-[#BBE1FF] rounded-[6px] rotate-[20.53deg] z-1"></div>
        <div className="absolute w-[101.62px] h-[125.35px] left-[-99.1px] top-[-51.05px] border-4 border-[#BBE1FF] rounded-[6px] rotate-[20.53deg] z-2"></div>

        {/* Content */}
        <div className="relative flex flex-col items-start gap-4 z-3 flex-1">
          <h3 className="text-3xl font-semibold mb-2">Increase your sales</h3>
          <p className="text-sm mb-4">
            Discover the Proven Methods to Skyrocket Your Sales! Unleash the Potential of Your Business and Achieve Remarkable Growth. Whether you're a seasoned entrepreneur or just starting out.
          </p>
          <button className="bg-white font-medium px-4 py-2 rounded-lg w-fit hover:bg-gray-100 transition">
            <span className="agarly-gradient-text font-bold text-[13px] leading-[150%] text-center">
              Learn More
            </span>
          </button>
        </div>
      </div>
    </div>
  </>
);
};
export default StatsCardsandBanner;
